import React, { useMemo } from 'react';
import { AddressElement } from '@stripe/react-stripe-js';
import {
  FormControl,
  Text,
  Input,
  FormLabel,
  FormErrorMessage,
} from '@chakra-ui/react';
import { useUIStore } from '#store';
import { validateEmail } from '#utils';

const AddressForm = () => {
  const { setAddress, setEmail, email, emailError, setEmailError, user } = useUIStore((state) => ({
    setAddress: state.setAddress,
    email: state.email,
    setEmail: state.setEmail,
    emailError: state.emailError,
    setEmailError: state.setEmailError,
    user: state.user,
  }));

  const handleEmailChange = (event) => setEmail(event.target.value);

  const handleEmailBlur = () => {
    if (validateEmail(email)) {
      setEmailError(null);
    } else {
      setEmailError('Invalid email address');
    }
  };
  const defaultValues = useMemo(
    () => {
      const ba = user?.billingAddress;
      const nameFromBilling = [ba?.firstName, ba?.lastName].filter(Boolean).join(' ');
      const nameFromProfile = [user?.firstName, user?.lastName].filter(Boolean).join(' ');
      return {
        name: nameFromBilling || nameFromProfile || '',
        address: {
          line1: ba?.line1,
          line2: ba?.line2 || undefined,
          city: ba?.city,
          state: ba?.state,
          postal_code: ba?.zipcode,
          country: ba?.country || 'US',
        },
      };
    },
    [user]
  );
  return (
    <FormControl>
      <Text
        fontSize="sm"
        fontWeight="semibold"
        letterSpacing="wider"
        color="gray.500"
        textTransform="uppercase"
        mb={2}
      >
        Billing Details
      </Text>
      {!user?.email && <FormControl isInvalid={!!emailError} mb={2}>
        <FormLabel fontWeight={'normal'} mb={0}>Email</FormLabel>
        <Input
          type="email"
          name="email"
          onChange={handleEmailChange}
          value={email}
          onBlur={handleEmailBlur}
        />
        <FormErrorMessage>{emailError}</FormErrorMessage>
      </FormControl>}
      <AddressElement
        options={{ mode: 'billing', defaultValues }}
        onChange={(event) => {
          if (event.complete) {
            const addr = event.value.address;
            const name = event.value.name;
            const nameParts = name.split(' ');

            const firstName = nameParts[0];
            const lastName = nameParts.slice(1).join(' ');
            setAddress({
              firstName,
              lastName,
              line1: addr.line1,
              line2: addr.line2,
              state: addr.state,
              country: addr.country,
              city: addr.city,
              zipcode: addr.postal_code,
            });
          }
        }}
      />
    </FormControl>
  );
};

export default AddressForm;
